"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useItems_1 = __importDefault(require("./useItems"));
const useItem_1 = __importDefault(require("./useItem"));
const useDraggingItem_1 = __importDefault(require("./useDraggingItem"));
const utils_1 = require("./utils");
function useIsClosestDragging(index) {
    const items = useItems_1.default();
    const draggingItem = useDraggingItem_1.default();
    const item = useItem_1.default();
    return react_1.default.useMemo(() => {
        if (!draggingItem) {
            return false;
        }
        const dragIndex = items.indexOf(draggingItem);
        const targetIndex = index === undefined ? item.index : index;
        return utils_1.isClosestOf(items, dragIndex, targetIndex);
    }, [items, draggingItem, item.index, index]);
}
exports.default = useIsClosestDragging;
